import { useState, useEffect } from 'react';
import SectionReveal from './SectionReveal';

const API_URL = 'https://nwt.am';

// Стандартные 3 поста (если нет с сервера)
const defaultPosts = [
    {
        title: 'Մաքրման կայանների առաջադեմ ավտոմատացում',
        date: 'Մարտ 2026',
        desc: 'Ինչպես խելացի սենսորների կիրառումը բարձրացնում է արդյունավետությունը և նվազեցնում ծախսերը։',
        image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?auto=format&fit=crop&w=800&q=80'
    },
    {
        title: 'Ջրի վերաօգտագործման նոր ռազմավարություններ',
        date: 'Փետրվար 2026',
        desc: 'Ինչպես կազմակերպությունները կարող են վերահսկել ջրի պահանջարկը և նվազեցնել կորուստները։',
        image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=800&q=80'
    },
    {
        title: 'Էկոլոգիական պահանջների համապատասխանություն',
        date: 'Հունվար 2026',
        desc: 'Արդյունավետ լուծումներ՝ բնապահպանական ստանդարտներին համապատասխանելու համար։',
        image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80'
    }
];

// Полноэкранная статья
function FullArticle({ post, onClose }) {
  if (!post) return null;

  return (
    <div className="fixed inset-0 z-50 animate-fadeIn">
      <div className="absolute inset-0 bg-white" onClick={onClose} />
      
      <div className="relative z-10 h-full overflow-y-auto">
        <button 
          onClick={onClose}
          className="fixed top-6 right-6 z-50 w-12 h-12 flex items-center justify-center bg-white border border-gray-200 hover:border-[#0FA4E8] text-[#0B3B6F] rounded-full transition-all hover:scale-110 shadow-sm"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>

        <div className="max-w-4xl mx-auto px-6 py-20 md:px-10">
          <span className="inline-block px-3 py-1 bg-[#0FA4E8] text-white text-xs font-bold uppercase tracking-wider animate-slideUp">
            {post.date}
          </span>
          
          <h2 className="text-3xl md:text-3xl font-black text-[#0B3B6F] mt-6 mb-8 leading-tight animate-slideUp" style={{ animationDelay: '100ms' }}>
            {post.title}
          </h2>
          
          <div className="relative h-[300px] md:h-[400px] overflow-hidden animate-zoomIn" style={{ animationDelay: '200ms' }}>
            <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
          </div>
          
          <div className="mt-10 space-y-6 animate-slideUp" style={{ animationDelay: '300ms' }}>
            <p className="text-lg text-slate-600 leading-relaxed">{post.desc}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

// Страница всех новостей
function AllNewsPage({ posts, onBack, onPostClick, t }) {
  return (
    <div className="fixed inset-0 z-40 bg-white animate-slideUp overflow-y-auto">
      <div className="max-w-6xl mx-auto px-3 py-6 md:px-10 md:py-12">
        
        <button onClick={onBack} className="group flex items-center gap-2 text-sm font-bold text-[#0B3B6F] hover:text-[#0FA4E8] transition-colors mb-8">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="group-hover:-translate-x-1 transition-transform">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          {t?.backButton || 'Назад'}
        </button>

        <h2 className="text-3xl md:text-5xl font-black text-[#0B3B6F] uppercase mb-10">
          {t?.allNewsTitle || 'Все новости'}
        </h2>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {posts.map((post, idx) => (
            <div key={idx} onClick={() => onPostClick(post)} className="group cursor-pointer border border-gray-100 hover:border-[#0FA4E8]/30 hover:shadow-lg transition-all animate-slideUp" style={{ animationDelay: `${idx * 80}ms` }}>
              <div className="relative h-48 overflow-hidden">
                {post.image ? (
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                ) : (
                  <div className="w-full h-full bg-gray-100" />
                )}
                <div className="absolute inset-0 bg-[#0B3B6F]/0 group-hover:bg-[#0B3B6F]/10 transition-colors" />
              </div>
              <div className="p-5">
                <span className="text-xs font-bold text-[#0FA4E8] uppercase tracking-wider">{post.date}</span>
                <h3 className="text-base font-bold text-[#0B3B6F] group-hover:text-[#0FA4E8] transition-colors mt-2 mb-2">{post.title}</h3>
                <p className="text-sm text-slate-500 line-clamp-3">{post.desc}</p>
                <div className="mt-3 flex items-center gap-1 text-xs font-bold text-[#0FA4E8] uppercase group-hover:gap-2 transition-all">
                  <span>{t?.blogReadMore || 'Читать'}</span>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function BlogSection({ t, lang = 'ARM' }) {
  const [selectedPost, setSelectedPost] = useState(null);
  const [showAllNews, setShowAllNews] = useState(false);
  const [serverPosts, setServerPosts] = useState([]);

  // Загружаем посты с сервера
  useEffect(() => {
    fetch(`${API_URL}/posts.php`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          setServerPosts(data);
        }
      })
      .catch(() => {
        // Сервер недоступен — остаются стандартные
      });
  }, []);

  // Функция локализации поста
  const localizePost = (post) => {
    const langMap = { ARM: 'arm', ENG: 'eng', RU: 'ru', RUS: 'ru' };
    const langKey = langMap[lang] || 'arm';
    
    return {
        ...post,
        title: post[`title_${langKey}`] || post.title || post.title_arm || '',
        desc: post[`desc_${langKey}`] || post.desc || post.desc_arm || '',
        content: post[`content_${langKey}`] || post.content || post.content_arm || '',
        date: post.date || post.created_at?.substring(0, 10) || '',
        image: post.image || '',
    };
};

  // Определяем посты
  let posts;
  if (serverPosts.length > 0) {
    // Посты с сервера — маппим по языку
    posts = serverPosts.map(localizePost);
  } else if (t?.posts?.length > 0) {
    // Посты из переводов
    posts = t.posts.map(localizePost);
  } else {
    // Стандартные
    posts = defaultPosts.map(localizePost);
  }

  const handlePostClick = (post) => {
    setSelectedPost(localizePost(post));
    setShowAllNews(false);
  };

  const handleAllNewsClick = (post) => {
    setSelectedPost(localizePost(post));
  };

  return (
    <section id="blog" className="relative bg-white px-3 py-20 md:px-10">
      
      <div className="mx-auto max-w-7xl space-y-12">
        
        <SectionReveal>
          <div className="border-l-4 border-[#0FA4E8] bg-gray-50 p-6 md:p-10">
            <h2 className="text-2xl md:text-4xl font-black text-[#0B3B6F] uppercase mb-3">
              {t?.newsTitle || t?.blogTitle || 'Նորություններ'}
            </h2>
            <p className="text-base text-slate-600">
              {t?.newsSubtitle || t?.blogSubtitle}
            </p>
          </div>
        </SectionReveal>

        <div className="grid gap-6 p-3 md:grid-cols-3">
          {posts.slice(0, 3).map((post, idx) => (
            <SectionReveal key={idx} delay={idx * 80}>
              <article onClick={() => handlePostClick(post)} className="group border border-gray-100 hover:border-[#0FA4E8]/30 transition-all bg-white hover:shadow-sm cursor-pointer">
                <div className="relative h-48 overflow-hidden">
                  {post.image ? (
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  ) : (
                    <div className="w-full h-full bg-gray-100" />
                  )}
                  <div className="absolute bottom-4 left-4">
                    <span className="inline-block px-3 py-1 bg-white text-xs font-bold uppercase tracking-wider text-[#0B3B6F]">
                      {post.date}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-base font-bold text-[#0B3B6F] group-hover:text-[#0FA4E8] transition-colors leading-snug mb-3">{post.title}</h3>
                  <p className="text-sm rounded-none text-slate-500 leading-relaxed line-clamp-3">{post.desc}</p>
                  <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between text-xs font-bold text-[#0FA4E8] uppercase tracking-wider">
                    <span>{t?.blogReadMore || 'Կարդալ ավելին'}</span>
                    <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
                  </div>
                </div>
              </article>
            </SectionReveal>
          ))}
        </div>

        <button onClick={() => setShowAllNews(true)} className="group inline-flex items-center gap-3 px-8 py-4 bg-[#0B3B6F] text-white font-bold uppercase tracking-wider text-sm hover:bg-[#0FA4E8] transition-all hover:shadow-lg">
          {t?.blogViewAll || 'Смотреть все новости'}
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="group-hover:translate-x-1 transition-transform">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </button>

      </div>

      {selectedPost && (
        <FullArticle post={selectedPost} onClose={() => setSelectedPost(null)} />
      )}

      {showAllNews && (
        <AllNewsPage posts={posts} onBack={() => setShowAllNews(false)} onPostClick={handleAllNewsClick} t={t} />
      )}
    </section>
  );
}